import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

import noop from 'lodash/noop';
import flatten from 'lodash/flatten';

import { formatMoney } from '../../../shared/format';

const propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	toggleAllRows: PropTypes.func,
	toggleOneRow: PropTypes.func,
	openedAffiliateIds: PropTypes.array
};

const Table = ({ table, intl, openedAffiliateIds, toggleOneRow, toggleAllRows, sortByColumn }) => (
	<div className="table-container table-container--projector redeem-wrap">
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<table className="simple-table simple-table--static redeem-wrap__table">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{table.headers.map((header, i) => (
								<th
									key={i}
									className={cn({
										'sort-header': header.direction,
										active: table.sortedColumn.index === header.index,
										[header.className]: header.className,
										[table.sortedColumn.direction]:
											table.sortedColumn.index === header.index && table.sortedColumn.direction
									})}
									onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
								>
									{intl(header.title)}
									{header.index === 'affiliate' && (
										<span
											className={cn({
												title__expand: true,
												'title__expand--opened': openedAffiliateIds.length
											})}
											onClick={e => {
												e.stopPropagation();
												toggleAllRows();
											}}
										>
											{openedAffiliateIds.length ? 'Close' : 'Open'}
										</span>
									)}
								</th>
							))}
						</tr>
					</thead>
					<tbody className="simple-table__body">{affiliateRows(table.rows, toggleOneRow, openedAffiliateIds)}</tbody>
				</table>
			</div>
		</div>
	</div>
);

const affiliateRows = (rows, toggleOneRow, openedAffiliateIds) => {
	const res = [];

	rows.forEach(row => {
		res.push(
			<tr
				className="redeem-table__affiliate-group-row"
				key={`aff-${row.affiliate_id}`}
				onClick={() => toggleOneRow(row.affiliate_id)}
			>
				<td className="redeem-table__affiliate">
					<span className="email">{row.affiliate}</span>
					<span
						className={cn(
							'expand__icon',
							openedAffiliateIds.indexOf(row.affiliate_id) !== -1 && 'expand__icon--opened'
						)}
					/>
				</td>
				<td className="redeem-table__total modify--right-position">
					<span className="redeem-table__quantity redeem-table__quantity--no-sep">
						{formatMoney(row.accepted_crm_conversions)}
					</span>
				</td>
				<td className="redeem-table__redeem modify--right-position">
					<div>
						<span className="redeem-table__percent">{row.redeem_percent}%</span>
						<span className="redeem-table__quantity">{formatMoney(row.redeemed_conversions)}</span>
					</div>
				</td>
				<td className="redeem-table__average-redeem modify--right-position" />
				<td className="redeem-table__redeem-deviation modify--right-position" />
			</tr>
		);

		if (openedAffiliateIds.indexOf(row.affiliate_id) !== -1 && row.offers) {
			res.push(offerRows(row));
		}
	});
	return flatten(res);
};

const offerRows = ({ affiliate_id, offers }) => {
	return offers.map(row => {
		return (
			<tr className="redeem-table__offer-group-row" key={`off-${affiliate_id}-${row.offer_id}`}>
				<td className="redeem-table__offer">
					<span>{row.title}</span>
				</td>
				<td className="redeem-table__total modify--right-position">
					<span className="redeem-table__quantity redeem-table__quantity--no-sep">
						{formatMoney(row.accepted_crm_conversions)}
					</span>
				</td>
				<td className="redeem-table__redeem modify--right-position">
					<div>
						<span className="redeem-table__percent">{row.redeem_percent}%</span>
						<span className="redeem-table__quantity">{formatMoney(row.redeemed_conversions)}</span>
					</div>
				</td>
				<td className="redeem-table__average-redeem modify--right-position">
					<span>{row.average_redeem_percent}%</span>
				</td>
				<td
					className={cn(
						'redeem-table__deviation modify--right-position',
						parseFloat(row.redeem_deviation) >= 0 ? 'more' : 'less'
					)}
				>
					<span>{Math.abs(parseFloat(row.redeem_deviation).toFixed(2))}%</span>
				</td>
			</tr>
		);
	});
};

Table.propTypes = propTypes;
export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-redeem/components/table/main.js